'use client';

import { cn } from '@ahm/common-helpers';
import { usePathname } from 'next/navigation';
import { useIsMobile } from '@/lib/is-mobile';

interface ContentWrapperProps {
  children: React.ReactNode;
}

export function ContentWrapper({ children }: ContentWrapperProps) {
  const pathname = usePathname();
  const isMobile = useIsMobile();

  const isInMobileFolder = pathname.match(/\/[^/]+\/(?:m|order-wv)(?:\/|$)/);
  const shouldAddPadding = !isInMobileFolder && !isMobile;

  return (
    <div className={cn('min-h-svh', shouldAddPadding && 'pb-20')}>
      {children}
    </div>
  );
}
